export const SOLID_CLIENT_COMPANY_IDS_FIELD_NAME = 'unarchivedClientCompanyIds';
export const QUOTA_ATTAINMENT_BY_TEAM_LAST_PERIOD_LABEL = 'What % of your sales team hit quota last period?';
export const TYPE_YOUR_ANSWER_HERE_PLACEHOLDER = 'Type your answer here';
export const QUOTA_ATTAINMENT_BASE_LABEL = 'What is your % quota attainment';
export const QUOTA_ATTAINMENT_LAST_PERIOD_LABEL = `${QUOTA_ATTAINMENT_BASE_LABEL} in the last period you worked?`;
export const QUOTA_ATTAINMENT_LAST_PERIOD__SHORT_LABEL = `${QUOTA_ATTAINMENT_BASE_LABEL} last period?`;

export const QUOTA_AND_DEALS_MODAL_TITLE = 'Quota & deals';
export const SALARY_AND_SALESPROCESS_MODAL_TITLE = 'Salary & sales process';

export const LINKEDIN_JOBS_HIRING_ID = 'linkedin-jobs-hiring';
